<script lang="ts" generics="ITEM">
    import type {SearchManager} from '../search-manager/search-manager';
    import KpRecordCliboardPanel
        from '../../record/kp-record-clipboard/kp-record-clipboard-panel/KpRecordCliboardPanel.svelte';
    import KpAuthorityIndexSearch from '../kp-authority-index-search/KpAuthorityIndexSearch.svelte';
    import KpSearchAdditionalFiltersPanel
        from '../kp-search-additional-filters/KpSearchAdditionalFiltersPanel.svelte';
    import KpSearchFacetsPanel from '../kp-search-facets/KpSearchFacetsPanel.svelte';

    export let searchManager: SearchManager<ITEM>;
</script>

<KpRecordCliboardPanel/>

<KpSearchAdditionalFiltersPanel {searchManager}/>

<KpSearchFacetsPanel {searchManager}/>

<KpAuthorityIndexSearch {searchManager}/>
